/* California Headstone Co. — AI Design Studio (front-end demo).
   Scoped to the section so multiple instances / Horizon theme editor
   re-renders stay safe. This is a visual simulation; in the live build
   the concept rendering is replaced by a real AI service call. */
(function () {
  function initStudio(root) {
    if (!root || root.dataset.chInit === '1') return;
    root.dataset.chInit = '1';

    var chips = root.querySelectorAll('.ch-chips .ch-chip');
    var placeholder = root.querySelector('.ch-placeholder');
    var loading = root.querySelector('.ch-loading');
    var stone = root.querySelector('.ch-stone');
    var genrow = root.querySelector('.ch-gen-row');
    var nameInput = root.querySelector('.ch-f-name');
    var sName = root.querySelector('.ch-s-name');
    var sMotif = root.querySelector('.ch-s-motif');
    var sEpi = root.querySelector('.ch-s-epi');
    var sCap = root.querySelector('.ch-s-cap');
    var stops = root.querySelectorAll('.ch-stone svg linearGradient stop');

    var motifs = {
      'Classic': '✦', 'Religious': '✝', 'Nature': '🌿',
      'Military / Veteran': '🎖', 'Modern': '◇', 'Floral': '❀'
    };
    var epitaphs = [
      'Forever in our hearts',
      'Beloved and never forgotten',
      'Until we meet again',
      'A life beautifully lived',
      'Gone from our sight, never from our hearts',
      'Rest in peace, dear soul'
    ];
    var granites = ['Barre Gray Granite', 'Jet Black Granite', 'Mahogany Granite'];
    // Visibly distinct stone colors per concept (top, bottom of the gradient).
    var graniteColors = [
      ['#8a8a80', '#45453d'], // Barre Gray
      ['#3a3a3a', '#121212'], // Jet Black
      ['#6f4b3a', '#38241b']  // Mahogany
    ];
    var conceptIndex = 0;

    chips.forEach(function (c) {
      c.addEventListener('click', function () { c.classList.toggle('ch-active'); });
    });

    function pickMotif() {
      var active = root.querySelectorAll('.ch-chips .ch-chip.ch-active');
      if (active.length) return motifs[active[0].textContent.trim()] || '✦';
      return '✦';
    }

    // Shrink an SVG <text> until it fits within maxWidth so it never spills out of the stone.
    function fitText(el, maxWidth, startSize) {
      if (!el) return;
      var fs = startSize;
      el.setAttribute('font-size', fs);
      if (typeof el.getComputedTextLength === 'function') {
        var guard = 0;
        try {
          while (el.getComputedTextLength() > maxWidth && fs > 5 && guard < 40) {
            fs -= 0.5;
            el.setAttribute('font-size', fs);
            guard++;
          }
        } catch (e) { /* element not rendered yet — keep startSize */ }
      }
    }

    function render() {
      var idx = conceptIndex % 3;
      var name = ((nameInput && nameInput.value) || 'In Loving Memory').toUpperCase();
      if (name.length > 28) name = name.slice(0, 28);
      if (sName) { sName.textContent = name; fitText(sName, 128, 15); }
      if (sMotif) sMotif.textContent = pickMotif();
      if (sEpi) { sEpi.textContent = '“' + epitaphs[conceptIndex % epitaphs.length] + '”'; fitText(sEpi, 142, 8); }
      if (sCap) sCap.textContent = 'Concept ' + (idx + 1) + ' of 3 · ' + granites[idx];
      // Change the stone color so each concept is visibly different.
      if (stops.length >= 2) {
        stops[0].setAttribute('stop-color', graniteColors[idx][0]);
        stops[1].setAttribute('stop-color', graniteColors[idx][1]);
      }
    }

    root.querySelectorAll('[data-ch-generate]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (placeholder) placeholder.style.display = 'none';
        if (stone) stone.style.display = 'none';
        if (genrow) genrow.style.display = 'none';
        if (loading) loading.style.display = 'flex';
        conceptIndex = 0;
        setTimeout(function () {
          if (loading) loading.style.display = 'none';
          if (stone) stone.style.display = 'flex';
          if (genrow) genrow.style.display = 'flex';
          render();
        }, 1100);
      });
    });

    root.querySelectorAll('[data-ch-variant]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        conceptIndex++;
        if (stone) {
          stone.style.animation = 'none';
          void stone.offsetWidth;
          stone.style.animation = 'ch-fade .5s ease';
        }
        render();
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ch-ai-studio]').forEach(initStudio);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
  // Re-init when a merchant edits the section in the theme editor.
  document.addEventListener('shopify:section:load', function (e) {
    var el = e.target.querySelector('[data-ch-ai-studio]');
    if (el) initStudio(el);
  });
})();
